<template>
  <div>
    <div
      :id="attrs.id"
      :class="attrs.class"
      v-html="profanity ? filterProfanity(output) : output"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["input", "safe"],

  data() {
    return {
      attrs: this.$attrs,
      output: "",
      profanity: false,
    };
  },
  created() {
    if (this.$attrs.id == null) {
      this.$attrs.id = Math.random()
        .toString(36)
        .slice(2);
    }
    this.profanity = _.get(this.$attrs, "profanity", false);
  },
  mounted() {
    this.parseMath();
  },
  methods: {
    parseMath() {
      let node = document.getElementById(this.attrs.id);
      if (MathJax.typesetClear) {
        MathJax.typesetClear([node]);
        this.output = this.input;
        Vue.nextTick(function() {
          MathJax.typesetPromise([node]).then(() => {});
        });
      }
    },
  },
  watch: {
    input: function(e) {
      this.parseMath();
    },
  },
  beforeDestroy() {
    let node = document.getElementById(this.attrs.id);
    if (MathJax.typesetClear) {
      if (node) {
        MathJax.typesetClear([node]);
      }
    }
  },
};
</script>
